import { render, staticRenderFns } from "./ForumThreadEditorPage.vue?vue&type=template&id=4b83a748&scoped=true"
import script from "./ForumThreadEditorPage.vue?vue&type=script&lang=js"
export * from "./ForumThreadEditorPage.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadEditorPage.vue?vue&type=style&index=0&id=4b83a748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83a748",
  null
  
)

export default component.exports